export default "__VITE_ASSET__dbf26f62__"